import { useMemo } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { interpolate, useTranslations } from 'common/language'
import { AlbumGalleryCard } from 'common/widgets/blocks'


QuoteDescription.propTypes = {
  data: PropTypes.object.isRequired,
}

function QuoteDescription({ data, ...props }) {
  const { gettext } = useTranslations()
  const dataObject = useMemo(() => ({ ...data, heading: interpolate(gettext('Why %s'), [data.heading]) }), [data])
  return (
    <AlbumGalleryCard {...props} data={dataObject} />
  )
}

export default connect((_, props) => ({
  data: {
    heading: get(props, 'school.name', ''),
    heading_level: '2',
    text: get(props, 'school.static_content.description', ''),
    images: get(props, 'school.static_content.media_images', []).slice(1),
  },
}))(QuoteDescription)
